<p-dialog
  header="New User"
  [style]="{ width: '50vw' }"
  [(visible)]="visibleUserDialog"
  [closable]="true"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="onClose(false)"
  [baseZIndex]="2004"
>
  <form [formGroup]="newUserForm">
    <div pFocusTrap class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label htmlFor="firstName">First Name*</label>
        <input
          id="firstName"
          #firstName
          tabindex="-1"
          formControlName="firstName"
          [class]="invalidField('firstName') ? 'ng-invalid ng-dirty' : ''"
          pInputText
          maxlength="250"
          (keydown)="handleInputTabIndex($event)"
        />
        <small
          class="block"
          *ngIf="invalidField('firstName')"
          id="name-help"
          class="p-error"
          >First Name is a required field.</small
        >
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label htmlFor="lastName">Last Name*</label>
        <input
          id="lastName"
          tabindex="-1"
          #lastName
          formControlName="lastName"
          [class]="invalidField('lastName') ? 'ng-invalid ng-dirty' : ''"
          pInputText
          maxlength="250"
          (keydown)="handleInputTabIndex($event)"
        />
        <small
          class="block"
          *ngIf="invalidField('lastName')"
          id="name-help"
          class="p-error"
          >Last Name is a required field.</small
        >
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label htmlFor="email">Email Address*</label>
        <input
          id="email"
          #email
          tabindex="-1"
          formControlName="emailAddress"
          [class]="invalidField('emailAddress') ? 'ng-invalid ng-dirty' : ''"
          pInputText
          maxlength="250"
          (keydown)="handleInputTabIndex($event)"
          (keydown.enter)="handleSubmit()"
        />

        <small
          class="block"
          *ngIf="invalidField('emailAddress')"
          id="name-help"
          class="p-error"
          >Enter a valid email address.</small
        >
      </div>
    </div>
  </form>
  <div class="box-button-right">
    <button
      tabindex="-1"
      pButton
      label="Cancel"
      class="p-button-raised p-button-secondary p-button-text p-mr-2"
      (click)="onClose(false)"
    ></button>
    <button
      [disabled]="isSaving"
      icon="pi pi-check"
      pButton
      [label]="isSaving ? 'Saving' : 'Save'"
      class="p-save"
      (click)="handleSubmit()"
    ></button>
  </div>
</p-dialog>
